export default {
  title: '海运拼箱运价',
  createTitle: '新建海运拼箱运价',
  editTitle: '编辑海运拼箱运价',
  viewTitle: '海运拼箱运价详情',
  copyTitle: '复制海运拼箱运价',
  filters: {
    priceNo: '运价号',
    carrier: '船公司',
    pol: '起运港',
    pod: '卸货港',
    por: '收货地',
    pdl: '目的港',
    podRouteCategory: '卸货港航线分类',
    rateType: '运价类型',
    status: '状态',
    validity: '有效期',
    originCountry: '起运国家',
    destinationCountry: '目的国家',
    originCity: '起运城市',
    destinationCity: '目的城市',
    placeOfDelivery: '收货地',
    portOfDischarge: '卸货港',
    supplier: '供应商',
    office: '所属公司',
    cargoType: '货物类型',
    directFlag: '直达/中转',
    transferPort: '中转港',
    lane: '目的航线',
    onePrice: '一口价',
    validPeriod: '有效期'
  },
  placeholders: {
    priceNo: '请输入运价号',
    source: '请选择运价来源',
    office: '请选择分公司',
    supplier: '请选择供应商',
    carrier: '请选择船公司',
    pol: '请选择起运港',
    pod: '请选择卸货港',
    por: '请选择收货地',
    pdl: '请选择目的港',
    portOfDischarge: '请选择卸货港',
    placeOfDelivery: '请选择收货地',
    podRouteCategory: '请选择卸货港航线分类',
    transportTerm: '请选择运输条款',
    validityDate: '请选择有效期',
    directFlag: '请选择直达/中转',
    rateType: '请选择运价类型',
    status: '请选择状态',
    validity: '请选择有效期',
    originCountry: '请选择起运国家',
    destinationCountry: '请选择目的国家',
    originCity: '请选择起运城市',
    destinationCity: '请选择目的城市',
    transferPort: '请选择中转港',
    lane: '请选择目的航线',
    onePrice: '请选择是否一口价',
    validPeriod: '请选择有效期范围',
    cargoType: '请选择货物类型',
    cargoDescription: '请输入货物描述',
    remark: '如截货时间、特殊要求、拆箱地点等',
    relationNo: '询价/招标单号',
    contractNo: '关联合约号',
    laneCodes: '请输入航线代码',
    departureDate: '选择开航日期',
    closingDate: '选择截关日期',
    sellPrice: '海运费单价',
    minCharge: '最低收费',
    nac: '请输入NAC',
    vessel: '请输入船名',
    voyage: '请输入航次',
    eta: '请选择预计到港日',
    etd: '请选择预计开航日',
    specialPriceStatus: '请选择特价状态'
  },
  columns: {
    priceNo: '运价号',
    rateType: '运价类型',
    carrier: '船公司',
    supplier: '供应商',
    pol: '起运港',
    pod: '卸货港',
    pdl: '目的港',
    source: '运价来源',
    chargeUnit: '计费单位',
    costPrice: '成本价',
    sellPrice: '销售价',
    sellPriceLabel: '销售卖价',
    spaceStatus: '舱位状态',
    validity: '有效期',
    status: '状态',
    actions: '操作',
    feeName: '费用名称',
    feeType: '费用类型',
    unit: '单位',
    price: '单价',
    currency: '币种',
    minCharge: '最低收费',
    maxCharge: '最高收费',
    payParam: '付费参数',
    payTerm: '付费方式',
    feeSource: '费用来源',
    oldValidity: '旧运价有效期',
    conflictType: '冲突类型',
    resolution: '处理策略'
  },
  fields: {
    priceNo: '运价号',
    rateType: '运价类型',
    carrier: '船公司',
    supplier: '供应商',
    cargoType: '货物类型',
    cargoDescription: '货物描述',
    spaceStatus: '舱位状态',
    priceTrend: '价格趋势',
    office: '分公司',
    contractNo: '约号',
    transportTerm: '运输方式',
    pol: '起运港',
    pod: '卸货港',
    transferPort: '中转港',
    validityDate: '有效期',
    transitTime: '时效(天)',
    chargeUnit: '计费单位',
    currency: '币种',
    costPrice: '成本单价',
    sellPrice: '销售单价',
    payTerm: '付费条款',
    minCharge: '最低收费',
    handlingFee: '操作费',
    customsFee: '报关费',
    baf: '燃油费',
    docFee: '文件费',
    directFlag: '直达/中转',
    source: '运价来源',
    relationNo: '关联单号',
    tradeTerm: '贸易条款',
    routeType: '航线类型',
    nac: 'NAC',
    por: '收货地',
    pdl: '目的港',
    placeOfDelivery: '收货地',
    portOfDischarge: '卸货港',
    podRouteCategory: '卸货港航线',
    polTerminal: '起运港码头',
    podTerminal: '卸货港码头',
    vessel: '船名',
    voyage: '航次',
    schedule: '班期',
    etd: 'ETD',
    eta: 'ETA',
    closingDate: '截关',
    departureDate: '开航',
    freeDetention: '免箱期(天)',
    freeDemurrage: '免堆期(天)',
    unstuffing: '拆箱/堆场',
    unstuffingPlace: '拆箱地点',
    receivingInstructions: '接货特殊说明',
    onePrice: '一口价',
    weightLimit: '限重(KG)',
    laneCodes: '航线代码',
    departureSchedule: '开航班期',
    closing_schedule: '截关班期',
    remark: '备注',
    baseOceanFreight: '基础海运费',
    manualAdd: '手工添加',
    systemRule: '系统规则',
    userCreated: '用户创建',
    viewRule: '查看规则',
    validPeriod: '有效期',
    specialPriceStatus: '特价状态'
  },
  enums: {
    source: {
      1: '手工录入',
      2: '询价入库',
      3: '招标入库',
      manual: '手工录入',
      inquiry: '询价入库',
      tender: '招标入库'
    },
    spaceStatus: {
      1: '畅接',
      2: '正常',
      3: '单票申请',
      4: '爆舱',
      5: '不接'
    },
    status: {
      1: '待上架',
      2: '正常',
      3: '失效',
      4: '下架',
      5: '禁用',
      6: '待导入'
    },
    cargoTypes: {
      general: '普货',
      dangerous: '危险品'
    },
    rateTypes: {
      1: '船东价格',
      2: 'NVO同行价格',
      3: '电商运价',
      4: '供应商报价'
    },
    chargeUnits: {
      cbm: 'CBM (体积)',
      kg: 'KG (重量)',
      weight: 'RT (计费重)'
    },
    payTerms: {
      prepaid: '预付',
      collect: '到付'
    },
    directFlags: {
      direct: '直达',
      transit: '中转',
      both: '直达/中转'
    },
    surchargeTypes: {
      OCEAN_EXTRA: '海运费附加费',
      POR: '起运港费用',
      FND: '卸货港费用'
    },
    routeTypes: {
      ocean: '直达',
      inland: '中转'
    },
    specialPriceStatus: {
      1: '不允许申请特价',
      2: '允许申请特价',
      3: '特价'
    }
  },
  sections: {
    basicInfo: '基础信息',
    routeInfo: '船期信息',
    feeInfo: '费用明细',
    surchargeDetail: '附加费明细',
    rateDetails: '运价明细',
    oceanFreight: '海运费',
    oceanFreightSurcharge: '海运附加费',
    polSurcharge: '起运港费用',
    podSurcharge: '目的港费用',
    remark: '备注'
  },
  actions: {
    add: '新增海运拼箱运价',
    query: '查询',
    reset: '重置',
    edit: '编辑',
    view: '详情',
    copy: '复制',
    delete: '删除',
    publish: '上架',
    disable: '禁用',
    enable: '启用',
    batchOperations: '批量操作',
    batchPublish: '批量上架',
    batchOffline: '批量下架',
    batchPriceChange: '批量改价',
    batchTimeChange: '批量改时间',
    batchDelete: '批量删除',
    import: '导入',
    export: '导出',
    downloadTemplate: '下载模板',
    aiRecognition: 'AI识别',
    more: '更多',
    back: '返回',
    saveDraft: '保存草稿',
    unbind: '解除绑定',
    addFeeManually: '手动添加费用',
    offline: '下架',
    cancel: '取消',
    confirm: '确定'
  },
  messages: {
    fetchFailed: '获取数据失败',
    loadDataFailed: '加载数据失败',
    saveSuccess: '草稿保存成功',
    publishSuccess: '成功上架 {count} 条运价',
    deleteSuccess: '成功删除 {count} 条运价',
    offlineSuccess: '成功下架 {count} 条运价',
    deleteConfirm: '确定要删除选中的 {count} 条运价吗？此操作不可恢复。',
    systemMatched: '系统规则已匹配',
    systemMatching: '匹配规则...',
    saving: '保存数据...',
    importSuccess: '导入成功',
    generatingErrorReport: '正在生成导出报表...',
    downloadingTemplate: '正在下载模板...',
    onlyDraftCanPublish: '只有草稿和待导入状态的运价才能上架，当前包含：{status}',
    onlyNormalCanOffline: '只有已发布状态的运价才能下架，当前包含：{status}',
    onlyDraftCanDelete: '只有草稿状态的运价才能删除，当前包含：{status}',
    offlineConfirm: '确定要将选中的 {count} 条运价下架吗？',
    noSelection: '请至少选择一条记录',
    batchUpdateSuccess: '批量更新成功',
    selectValidity: '请选择有效期',
    onlyDraftCanModify: '只能修改草稿状态',
    recordsToModify: '将被修改的运价列表',
    selectedCount: '已选择 {count} 项',
    noSurchargeRuleId: '未找到关联的附加费规则ID',
    unknownSurchargeType: '未知的附加费类型，无法跳转',
    comingSoon: '敬请期待',
    exportFilename: '海运拼箱运价导出',
    templateDownloadFailed: '模板下载失败'
  },
  batch: {
    timeChange: {
      currentEtd: '当前 ETD',
      currentEta: '当前 ETA',
      currentValidPeriod: '当前有效期'
    }
  },
  modals: {
    conflictTitle: '发现有效期冲突',
    processing: '处理中...',
    confirmProcessing: '确认处理并继续发布',
    cancelPublish: '取消发布',
    conflictAlert: '检测到 {count} 条现有运价与本次发布的运价有效期存在冲突。',
    upcomingRate: '即将发布的运价',
    conflictDetail: '冲突运价明细及处理策略',
    ruleTitle: '有效期冲突自动处理规则',
    rule1: '完全一致',
    rule2: '新完全包含旧',
    rule3: '存在交集',
    rule4: '旧完全包含新'
  },
  aiRecognition: {
    title: 'AI智能识别',
    uploadTitle: '上传运价文件',
    uploadDesc: '点击或拖拽文件到此区域，系统将自动识别内容并提取运价信息',
    processing: 'AI正在识别中...',
    processingDesc: '请稍候，AI正在分析您的运价文件...',
    success: '识别成功！',
    successDesc: '运价信息已成功识别并导入',
    error: '识别失败',
    errorDesc: '文件识别失败，请检查文件格式或重新上传',
    retry: '重新上传',
    aiDescription: 'AI识别说明',
    aiFeatures: [
      'AI将自动识别运价表格中的港口、船公司、价格等信息',
      '支持多种文件格式 and 复杂表格结构',
      '识别完成后会创建后台任务进行处理',
      '请确保上传的文件清晰可读'
    ],
    successTitle: 'AI识别任务已提交',
    successDescription: '当前任务后台正在运行中，请到<strong>系统设置 - 任务管理</strong>中查看任务进度与结果。',
    goToTaskManagement: '前往任务管理',
    close: '关闭',
    uploadFile: '上传{type}文件',
    clickOrDrag: '点击或拖拽文件到此区域上传',
    supportedFormats: '支持格式：PDF、Excel、Word、图片等',
    selectFile: '选择文件',
    aiParsing: 'AI解析中...',
    aiParsingTip: 'AI正在解析文档，请稍候...'
  },
  form: {
    sections: {
      basicInfo: '基础信息',
      routeInfo: '路线信息',
      validityInfo: '时效信息',
      feeInfo: '费用明细',
      specialTerms: '特殊条款',
      remark: '备注'
    },
    labels: {
      priceName: '运价名称',
      supplier: '供应商',
      carrier: '船司',
      pol: '起运港',
      pod: '目的港',
      transitPort: '中转港',
      validityDate: '有效期',
      transitTime: '时效(天)',
      chargeUnit: '计费单位',
      currency: '币种',
      freightPrice: '运费单价',
      minCharge: '最低消费',
      handlingFee: '操作费',
      customsFee: '报关费',
      baf: '燃油附加费(BAF)',
      docFee: '文件费',
      freeStorageDays: '免费堆存期(天)',
      volumeLimit: '体积限制(CBM)',
      weightLimit: '重量限制(KG)',
      specialCargoRemark: '特殊货物说明',
      remark: '备注'
    },
    placeholders: {
      priceName: '请输入运价名称',
      supplier: '请选择供应商',
      carrier: '请选择船司',
      pol: '请选择起运港',
      pod: '请选择目的港',
      transitPort: '请选择中转港（可多选）',
      transitTime: '请输入预计航程天数',
      currency: '请选择币种',
      freightPrice: '请输入运费单价',
      minCharge: '请输入最低消费金额',
      handlingFee: '请输入操作费',
      customsFee: '请输入报关费',
      baf: '请输入燃油附加费',
      docFee: '请输入文件费',
      freeStorageDays: '请输入免费堆存期',
      volumeLimit: '请输入最大体积限制',
      weightLimit: '请输入最大重量限制',
      specialCargoRemark: '请输入特殊货物说明，如带电、危险品等',
      remark: '请输入其他补充说明'
    },
    options: {
      chargeUnitWeight: '计费重'
    },
    validation: {
      priceName: '请输入运价名称',
      supplier: '请选择供应商',
      carrier: '请选择船司',
      pol: '请选择起运港',
      pod: '请选择目的港',
      validityDate: '请选择有效期',
      chargeUnit: '请选择计费单位',
      currency: '请选择币种',
      freightPrice: '请输入运费单价'
    },
    ports: {
      CNSHA: '上海港 (CNSHA)',
      CNSZX: '深圳港 (CNSZX)',
      CNYTN: '盐田港 (CNYTN)',
      USLAX: '洛杉矶港 (USLAX)',
      NLRTM: '鹿特丹港 (NLRTM)',
      DEHAM: '汉堡港 (DEHAM)'
    }
  }
}
